const PHRASES = [
  "VAIYRA",
  "ROOTED IN GRACE",
  "SHORT KURTAS",
  "LONG KURTAS",
  "CORD SETS",
  "HANDCRAFTED SEAMS",
  "THE DEBUT COLLECTION",
];

const Marquee = () => {
  const row = [...PHRASES, ...PHRASES, ...PHRASES];
  return (
    <div data-testid="editorial-marquee" className="bg-maroon-ink py-5 overflow-hidden border-y border-gold/30">
      <div className="marquee-track flex whitespace-nowrap w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((phrase, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-display italic text-xl sm:text-2xl text-gold-light/80 px-8">{phrase}</span>
                <svg viewBox="0 0 24 24" className="w-3.5 h-3.5 text-gold" fill="currentColor">
                  <path d="M12 2l2.4 7.6L22 12l-7.6 2.4L12 22l-2.4-7.6L2 12l7.6-2.4z" />
                </svg>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
